import { gql } from "@apollo/client";

export const GET_PROFESIONAL_MONITOREO_COMBOS = gql`
    query GetProfesionalMonitoreoCombos {
        profesionalMonitoreoCombos{
            profMonitoreoEntrenamiento{
                id
                descripcion
                resta
            }
            profMonitoreoVisitas {
                id
                descripcion
                resta
            }
            profMonitoreoCompletitud {
                id
                descripcion
                resta
            }
            profMonitoreoResultado {
                id
                descripcion
            }
        }
    }
`;

export const adaptProfMonitoreo = (profMonitoreo) => {
  return {
    id: profMonitoreo?.id,
    displayName: profMonitoreo?.descripcion,
    resta: profMonitoreo?.resta
  };
};

export const adaptProfesionalMonitoreoCombos = (data) => {
  return {
    entrenamiento: data?.profMonitoreoEntrenamiento?.map((x) => adaptProfMonitoreo(x)) || [],
    visitas: data?.profMonitoreoVisitas?.map((x) => adaptProfMonitoreo(x)) || [],
    completitud: data?.profMonitoreoCompletitud?.map((x) => adaptProfMonitoreo(x)) || [],
    resultado: data?.profMonitoreoResultado?.map((x) => adaptProfMonitoreo(x)) || []
  };
};